import create from 'zustand';

export const useNewVersionAvailability = create<{
  isNewVersionAvailable: string | null;
  setIsNewVersionAvailable: (isNewVersionAvailable: string | null) => void;
}>((set) => ({
  isNewVersionAvailable: null,
  setIsNewVersionAvailable: (isNewVersionAvailable: string | null) =>
    set((state) => ({ ...state, isNewVersionAvailable })),
}));
